module.exports = __webpack_public_path__ + "img/vsBombshell1.773dd738.jpg";